import { render, staticRenderFns } from "./DetailReportTable.vue?vue&type=template&id=a863ad12"
import script from "./DetailReportTable.vue?vue&type=script&lang=js"
export * from "./DetailReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports